import type { BreakpointsConfig } from "@foundation/screen/lib/types";

import mediaQueries from "../tailwindconfig/media-queries";

export const getBreakpointMap = (
    breakpoints: { breakpoint: keyof typeof mediaQueries; name: string }[]
): BreakpointsConfig => {
    return breakpoints.reduce(
        (acc: BreakpointsConfig, { breakpoint: breakpointName, name }) => {
            const breakpoint = (
                mediaQueries as Record<
                    string,
                    string | { min?: string; max?: string; raw?: string }
                >
            )[breakpointName];

            if (!breakpoint) {
                return acc;
            }

            const breakpointValues = {} as { min?: number; max?: number };

            if (typeof breakpoint === "string") {
                breakpointValues.min = Number(breakpoint.replace("px", ""));
            } else if (typeof breakpoint === "object") {
                const { min, max } = breakpoint;

                if (min) {
                    breakpointValues.min = Number(min.replace("px", ""));
                }

                if (max) {
                    breakpointValues.max = Number(max.replace("px", ""));
                }
            }

            acc[name] = breakpointValues;

            return acc;
        },
        {}
    );
};
